var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _rect8, _rect9, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitedVisibilityDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 97,
    viewBox: "0 0 217 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.14209,
    width: 75.0156,
    height: 4.83984,
    rx: 2.41992,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 17.9819,
    width: 47.187,
    height: 4.83984,
    rx: 2.41992,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 48.9058,
    width: 16.5127,
    height: 47.5278,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5127,
    y: 71.6162,
    width: 16.5127,
    height: 24.8174,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.0254,
    y: 43.2173,
    width: 16.5127,
    height: 53.2163,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5381,
    y: 62.5762,
    width: 16.5127,
    height: 33.8574,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102.051,
    y: 29.8218,
    width: 16.5127,
    height: 66.6118,
    rx: 2,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.211 33.377C216.211 51.8105 200.74 66.7539 181.654 66.7539C162.569 66.7539 147.097 51.8105 147.097 33.377C147.097 14.9434 162.569 0 181.654 0C200.74 0 216.211 14.9434 216.211 33.377ZM165.037 33.377C165.037 42.241 172.476 49.4268 181.654 49.4268C190.832 49.4268 198.271 42.241 198.271 33.377C198.271 24.5129 190.832 17.3271 181.654 17.3271C172.476 17.3271 165.037 24.5129 165.037 33.377Z",
    fill: "#D1D4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.402 1.65539C200.418 4.18895 207.198 9.46627 211.464 16.4931C215.73 23.5199 217.189 31.8111 215.565 39.8046L197.96 36.4678C198.741 32.624 198.04 28.6371 195.989 25.2581C193.937 21.8791 190.677 19.3415 186.822 18.1232L192.402 1.65539Z",
    fill: "#E0E2E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.572 39.7684C214.457 45.2878 211.916 50.4457 208.186 54.7631C204.455 59.0806 199.655 62.4177 194.232 64.4645L187.702 48.3259C190.31 47.3416 192.618 45.7369 194.412 43.6608C196.206 41.5847 197.428 39.1045 197.964 36.4504L215.572 39.7684Z",
    fill: "#98A0B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 147.097,
    y: 80.7539,
    width: 69.1147,
    height: 4.83984,
    rx: 2.41992,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 147.097,
    y: 91.5938,
    width: 69.1147,
    height: 4.83984,
    rx: 2.41992,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.105 57.0977C119.279 57.0977 128.338 65.9032 128.338 76.7656C128.338 87.6281 119.279 96.4336 108.105 96.4336C96.9319 96.4334 87.874 87.628 87.874 76.7656C87.874 65.9033 96.9319 57.0978 108.105 57.0977ZM108.105 73.6602L101.594 67.3301L98.3994 70.4355L104.911 76.7656L98.3994 83.0967L101.594 86.2021L108.105 79.8711L114.617 86.2021L117.812 83.0967L111.3 76.7656L117.812 70.4355L114.617 67.3301L108.105 73.6602Z",
    fill: "#D92D17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedVisibilityDashboard);
export default __webpack_public_path__ + "static/media/limited-visibility-dashboard.f6d9d509ef2585eefd320994b3c8230c.svg";
export { ForwardRef as ReactComponent };